import { render } from "./CreateUserForm.vue?vue&type=template&id=221ded2f"
import script from "./CreateUserForm.vue?vue&type=script&lang=js"
export * from "./CreateUserForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__